var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 2000 2000"
    },
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st6{fill:#fff}")), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M163.6 164.2h1672.8V1837H163.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_2_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_3_",
    cx: 1000,
    cy: 1000.6,
    r: 836.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_4_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.6 164.2h1672.8V1837H163.6V164.2z",
    style: {
      fill: "#fec112"
    }
  }))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M15.6 16.1h1969v1969H15.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000 16.1c-543.2 0-984.4 441.3-984.4 984.4 0 543.1 441.3 984.4 984.4 984.4 543.1 0 984.4-441.3 984.4-984.4 0-543.1-441.3-984.4-984.4-984.4zm0 42.8c520.6 0 941.6 421 941.6 941.6s-421 941.6-941.6 941.6-941.6-421-941.6-941.6c0-520.5 421-941.6 941.6-941.6z",
    style: {
      fill: "#f7931f"
    }
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M932 789.3h605v769H932z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1532.2 988.8 1332 794.5c-4.6-4.4-11.2-5.6-16.9-3.1-5.9 2.5-9.5 8.1-9.5 14.5v119.6c-96.2 7.2-186.6 48.7-255.1 117.2-76.3 76.3-118.4 177.8-118.4 285.6v214.9c0 8.6 7 15.6 15.6 15.6s15.6-7 15.6-15.6v-214.9c0-99.5 38.8-193.1 109.1-263.6 66.7-66.7 155.2-105.4 249.3-108.9 8.5-.3 15.1-7.2 15.1-15.6v-97.4L1499 1000l-162.3 157.3v-96.6c0-4.3-1.8-8.5-4.9-11.3-3.1-2.9-7.3-4.4-11.6-4.3-72.3 3.9-139.6 35.2-189.8 87.9-50.3 52.9-78 122.2-78 195.1V1543c0 8.6 7 15.6 15.6 15.6s15.6-7 15.6-15.6v-214.9c0-128.5 94.9-235.2 221.8-250.3v116.6c0 6.2 3.8 12 9.5 14.5s12.5 1.2 16.9-3.1l200.2-194.3c3-2.9 4.7-7 4.7-11.2.2-4.5-1.5-8.5-4.5-11.5z",
    className: "st6",
    style: {
      clipPath: "url(#SVGID_8_)"
    }
  }), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M463 789.3h491.7v421.3H463z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M678.2 955.7c94 3.5 182.6 42.2 249.3 108.9 6.1 6.1 16 6.1 22.1 0 6.1-6.1 6.1-16 0-22.1-68.5-68.5-158.9-110-255.1-117.2V805.7c0-6.2-3.8-12-9.5-14.5s-12.5-1.2-16.9 3.1L467.7 988.8c-3 2.9-4.7 7-4.7 11.2 0 4.2 1.7 8.3 4.7 11.2l200.2 194.3c3 2.9 6.8 4.4 10.9 4.4 2.1 0 4.2-.4 6.1-1.2 5.9-2.5 9.5-8.1 9.5-14.5v-116.6c78 9.5 147.9 55.5 187.8 124.1 2.1 3.6 5.5 6.2 9.5 7.3 4 1 8.2.5 11.8-1.6 7.4-4.3 10-13.9 5.6-21.4-48.3-83.1-134.1-135.8-229.6-141-4.3-.3-8.5 1.3-11.6 4.3-3.1 3-4.9 7-4.9 11.3v96.6L501 999.8l162.1-157.3v97.4c0 8.7 6.6 15.4 15.1 15.8z",
    className: "st6",
    style: {
      clipPath: "url(#SVGID_10_)"
    }
  }), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_11_",
    d: "M793.3 441.3h421.3V996H793.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M810.2 672.6H932v307.5c0 8.6 7 15.6 15.6 15.6s15.6-7 15.6-15.6V657c0-8.6-7-15.6-15.6-15.6H847.2l157.3-162.1 157.3 162.1h-101.3c-8.6 0-15.6 7-15.6 15.6v323.1c0 8.6 7 15.6 15.6 15.6s15.6-7 15.6-15.6V672.6h122.7c6.3 0 12-3.8 14.5-9.5s1.2-12.5-3.1-16.9L1015.8 446c-2.9-3-7-4.7-11.2-4.7-4.2 0-8.3 1.7-11.2 4.7L799 646.2c-4.4 4.6-5.6 11.2-3.1 16.9 2.5 5.8 8.1 9.5 14.3 9.5z",
    className: "st6",
    style: {
      clipPath: "url(#SVGID_12_)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1);
export default __webpack_public_path__ + "static/media/img1.d6672b4fd75f312af71d137a0508b835.svg";
export { ForwardRef as ReactComponent };